import {useEffect, useState} from "react";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const UseSse = () => {
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        const eventSource = new EventSource(API_KEEPER + "/user-messages/sse");

        eventSource.onmessage = event => {
            const parsedData = JSON.parse(event.data);
            if (parsedData.length > 0) {
                setMessages(prev => {
                    return parsedData.reduce((acc, item) => {
                        if (item.remove) return acc.filter(old => old.id !== item.id);
                        else if (!acc.some(old => old.id === item.id)) acc.push(item);
                        else {
                            const find = acc.find(old => old.id === item.id);
                            find.status = item.status;
                            find.favorite = item.favorite;
                        }

                        return acc;
                    }, [...prev]);
                });
            }
        };

        eventSource.onerror = e => {
            console.error('Error to load events.');
            console.error(e);
        };

        return () => eventSource.close();
    }, []);

    return { messages };
};

export default UseSse;